import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';

import {DashboardDepotPunctuality} from '../../interfaces/DashboardPunctuality';
import {DashboardComponent} from '../dashboard/dashboard.component';

@Component({
  selector: 'app-dashboard-charts',
  templateUrl: './dashboard-charts.component.html',
  styleUrls: ['./dashboard-charts.component.scss']
})
export class DashboardChartsComponent {
  @Input() public settings: DashboardComponent['settings'];
  @Input() public punctuality: DashboardDepotPunctuality[];
  @ViewChild('chartsWrapper', {static: true}) public chartsWrapper: ElementRef;
}

